export default __webpack_public_path__ + "switch.ca905b107a43652c.svg";